import React from "react";
import { Label } from "../ui/label";

const LEVELS = [
  ["hidden", "Gizli"],
  ["view", "Görüntüle"],
  ["edit", "İşlem Yap"],
];

export const InstallationTabPermissions = ({ tabs, value, onChange, title = "Montaj Sayfası Sekme Yetkileri", testId = "installation-tab-permissions" }) => (
  <div data-testid={testId}>
    <Label>{title}</Label>
    <div className="mt-2 border rounded-lg divide-y">
      {tabs.map((tab) => {
        const current = value[tab.key] || "edit";
        return (
          <div key={tab.key} className="flex items-center justify-between gap-2 px-3 py-2">
            <span className="text-sm font-medium">{tab.label}</span>
            <div className="flex rounded-md border overflow-hidden">
              {LEVELS.map(([level, label]) => (
                <button
                  key={level}
                  type="button"
                  onClick={() => onChange({ ...value, [tab.key]: level })}
                  className={`px-2.5 py-1 text-xs transition-colors ${current === level
                    ? level === "hidden" ? "bg-gray-700 text-white" : level === "view" ? "bg-amber-500 text-white" : "bg-green-600 text-white"
                    : "bg-white text-gray-600 hover:bg-gray-100"}`}
                  data-testid={`tab-perm-${tab.key}-${level}`}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </div>
    <p className="text-xs text-gray-500 mt-1">Gizli: sekme hiç görünmez • Görüntüle: butonlar kapalı • İşlem Yap: tam yetki</p>
  </div>
);
